import { format } from 'date-fns';
import { useEffect, useState } from 'react';

export const useCurrentTime = (timeFormat: string) => {
  const [currentTime, setCurrentTime] = useState(format(new Date(), timeFormat));

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(format(new Date(), timeFormat));
    }, 1000);
    return () => clearInterval(interval);
  }, [timeFormat]);

  return currentTime;
};
